module.exports = "<p>\n  order-details works!\n</p>\n"